module.exports = __webpack_public_path__ + "img/bg-data.7407bd40.png";